module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "aria-labelledby": "headerabbrev01",
      "epub:type": "frontmatter",
      "id": "abbrev"
    }
  }, [_c('header', {
    attrs: {
      "id": "headerabbrev01"
    }
  }, [_c('h1', {
    staticClass: "ctfm"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": " Page x. ",
      "epub:type": "pagebreak",
      "id": "px",
      "role": "doc-pagebreak"
    }
  }), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": " Page xi. ",
      "epub:type": "pagebreak",
      "id": "pxi",
      "role": "doc-pagebreak"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chifoucaultcritique0006#rabbrev"
    }
  }, [_vm._v("Abbreviations of Works by Michel Foucault")])])]), _vm._v(" "), _c('table', {
    staticStyle: {
      "border-bottom": "0"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("AB")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("Abnormal: Lectures at the Collège de France, 1974–1975")]), _vm._v(", ed. V. Marchetti and A. Salomoni, trans. Graham Burchell, English series ed. Arnold I. Davidson (New York: Picador, 2003).")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("ABHS")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("About the Beginning of the Hermeneutics of the Self: Lectures at Dartmouth College, 1980")]), _vm._v(", ed. Henri-Paul Fruchaud and Daniele Lorenzini, trans. Graham Burchell (Chicago: University of Chicago Press, 2016).")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("AK")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("The Archaeology of Knowledge")]), _vm._v(", 2nd ed., trans. A. M. Sheridan Smith (London: Routledge, 2002).")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("CS")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("The Care of the Self")]), _vm._v(", vol. 3 of "), _c('i', [_vm._v("The History of Sexuality")]), _vm._v(", trans. Robert Hurley (London: Penguin, 1990).")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("CT")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("The Courage of Truth")]), _vm._v(": "), _c('i', [_vm._v("Lectures at the Collège de France, 1983–1984")]), _vm._v(", ed. Frédéric Gros, trans. Graham Burchell, English series ed. Arnold I. Davidson (New York and Basingstoke: Palgrave Macmillan, 2010).")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("DE I")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("Dits et Écrits I, 1954–1975")]), _vm._v(", ed. Daniel Defert and François Ewald with the collaboration of Jacques Lagrange (Paris: Gallimard, 2001).")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("DE II")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("Dits et Écrits II, 1976–1988")]), _vm._v(", ed. Daniel Defert and François Ewald with the collaboration of Jacques Lagrange (Paris: Gallimard, 2001).")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("DP")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("Discipline and Punish: The Birth of the Prison")]), _vm._v(", trans. Alan Sheridan (London: Penguin, 1991).")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": " Page xii. ",
      "epub:type": "pagebreak",
      "id": "pxii",
      "role": "doc-pagebreak"
    }
  }), _c('abbr', [_vm._v("EW 1")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("The Essential Works of Foucault, 1954–1984")]), _vm._v(", vol. 1, "), _c('i', [_vm._v("Ethics: Subjectivity and Truth")]), _vm._v(", ed. Paul Rabinow (New York: New Press, 1997).")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("EW 2")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("The Essential Works of Foucault, 1954–1984")]), _vm._v(", vol. 2, "), _c('i', [_vm._v("Aesthetics, Method, and Epistemology")]), _vm._v(", ed. James D. Faubion (New York: New Press, 1998).")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("EW 3")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("The Essential Works of Foucault, 1954–1984")]), _vm._v(", vol. 3, "), _c('i', [_vm._v("Power")]), _vm._v(", ed. James D. Faubion (New York: New Press, 2000).")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("FL")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("Foucault Live: Collected Interviews, 1961–1984")]), _vm._v(", ed. Sylvère Lotringer, trans. Lysa Hochroth and John Johnston (New York: Semiotext(e), 1996).")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("GL")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("On the Government of the Living: Lectures at the Collège de France, 1979–1980")]), _vm._v(", ed. Michel Senellart, trans. Graham Burchell, English series ed. Arnold I. Davidson (New York and Basingstoke: Palgrave Macmillan, 2014).")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("GSO")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("The Government of Self and Others: Lectures at the Collège de France, 1982–1983")]), _vm._v(", ed. Frédéric Gros, trans. Graham Burchell, English series ed. Arnold I. Davidson (New York and Basingstoke: Palgrave Macmillan, 2010).")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("HIST")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("The History of Sexuality")]), _vm._v(", vol. 1, "), _c('i', [_vm._v("An Introduction")]), _vm._v(", trans. Robert Hurley (New York: Random House, 1978).")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("HS")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("The Hermeneutics of the Subject: Lectures at the Collège de France, 1981–1982")]), _vm._v(", ed. Frédéric Gros, trans. Graham Burchell, English series ed. Arnold I. Davidson (New York and Basingstoke: Palgrave Macmillan, 2005).")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("PP")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("Psychiatric Power: Lectures at the Collège de France, 1973–1974")]), _vm._v(", ed. Jacques Lagrange, trans. Graham Burchell, English series ed. Arnold I. Davidson (New York and Basingstoke: Palgrave Macmillan, 2010).")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("ST")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("Subjectivity and Truth: Lectures at the Collège de France, 1980–1981")]), _vm._v(". ed. Frédéric Gros, trans. Graham Burchell, English series ed. Arnold I. Davidson (New York and Basingstoke: Palgrave Macmillan, 2017).")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("STP")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("Security, Territory, Population: Lectures at the Collège de France, 1977–1978")]), _vm._v(", ed. Michel Senellart, trans. Graham Burchell, "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": " Page xiii. ",
      "epub:type": "pagebreak",
      "id": "pxiii",
      "role": "doc-pagebreak"
    }
  }), _vm._v("English series ed. Arnold I. Davidson (New York and Basingstoke: Palgrave Macmillan, 2007).")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("UP")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("The Use of Pleasure")]), _vm._v(", vol. 2 of "), _c('i', [_vm._v("The History of Sexuality")]), _vm._v(", trans. Robert Hurley (London: Penguin, 1985).")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_c('abbr', [_vm._v("WDTT")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_c('i', [_vm._v("Wrong-Doing, Truth-Telling: The Function of Avowal in Justice")]), _vm._v(", ed. Fabienne Brion and Bernard E. Harcourt, trans. Stephen W. Sawyer (Chicago: University of Chicago Press, 2014).")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-90bb6a6c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-foucault-critique-0009.vue
// module id = 78
// module chunks = 0